import QueryString from "query-string";
import { all, call, put, select, takeEvery } from "redux-saga/effects";
import api from "../../utils/api";
import { errorAlert, successAlert } from "../Alerts/actions";
import {
  addNewsFailure,
  //
  addNewsSuccess,
  deleteNewsFailure,
  //
  deleteNewsSuccess,
  editNewsFailure,
  //
  editNewsSuccess,
  fetchNews as fetchNewsAction,
  fetchNewsFailure,
  fetchNewsSuccess,
  //
  getViewData as getViewDataAction,
  getViewDataFailure,
  getViewDataSuccess,
} from "./actions";
import {
  ADD_NEWS,
  DELETE_NEWS,
  EDIT_NEWS,
  FETCH_NEWS,
  GET_VIEW_DATA,
} from "./constants";

export function* fetchNewsSaga({ payload = { cancelToken: null } }) {
  const token = yield select((state) => state?.AuthReducer?.token);

  let query = payload ? QueryString.stringify(payload?.data) : "";
  try {
    const { data } = yield call(api(token).get, `/api/news?${query}`);
    yield put(fetchNewsSuccess(data));
  } catch (e) {
    yield put(fetchNewsFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching news!"));
  }
}

export function* getViewDataSaga({ payload = { cancelToken: null } }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  let query = payload ? QueryString.stringify(payload) : "";
  try {
    const { data } = yield call(api(token).get, `/api/news/${payload}`);
    yield put(getViewDataSuccess(data));
  } catch (e) {
    yield put(getViewDataFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching data!"));
  }
}

export function* addNewsSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(api(token).post, `/api/news/add`, payload.data);
    if (data) {
      yield put(successAlert("News added successfully!"));
      yield put(addNewsSuccess());
      if (payload?.history) {
        payload.history.push("/d/news");
      }
    }
  } catch (e) {
    yield put(addNewsFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* editNewsSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(
      api(token).post,
      `/api/news/edit/${payload.id}`,
      payload.data
    );
    if (data) {
      yield put(successAlert("News updated successfully!"));
      yield put(editNewsSuccess());
      yield put(getViewDataAction(payload.id));
    }
  } catch (e) {
    yield put(editNewsFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* deleteNewsSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(api(token).delete, `/api/news/${payload}`);
    if (data) {
      yield put(successAlert("News deleted successfully!"));
      yield put(deleteNewsSuccess());
      yield put(fetchNewsAction());
    }
  } catch (e) {
    yield put(deleteNewsFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* fetchNewsFlow() {
  yield takeEvery(FETCH_NEWS, fetchNewsSaga);
}
export function* getViewDataFlow() {
  yield takeEvery(GET_VIEW_DATA, getViewDataSaga);
}
export function* addNewsFlow() {
  yield takeEvery(ADD_NEWS, addNewsSaga);
}
export function* editNewsFlow() {
  yield takeEvery(EDIT_NEWS, editNewsSaga);
}
export function* deleteNewsFlow() {
  yield takeEvery(DELETE_NEWS, deleteNewsSaga);
}
export default function* NewsSaga() {
  yield all([
    fetchNewsFlow(),
    addNewsFlow(),
    editNewsFlow(),
    deleteNewsFlow(),
    getViewDataFlow(),
  ]);
}
